import { isNotNullOrUndef } from '../../utils/isNotNullOrUndef';
const findDesiredRoomInLayout = (l, rooms) => {
    return l.room_previews.find(({ room_type }) => {
        return isNotNullOrUndef(room_type) && rooms.includes(room_type.toLowerCase());
    });
};
export const getURLsFromHit = ({ shapes, pieces, types, rooms, names, item, selectedLayout }) => {
    const hasActiveFilter = shapes.length > 0 || pieces.length > 0 || types.length > 0 || names.length > 0;
    let previewImage;
    let isSelectedLayout = false;
    if (selectedLayout === undefined) {
        selectedLayout = item.layouts.find((l) => {
            if (hasActiveFilter) {
                return !((names.length > 0 && !names.includes(l.name.toLowerCase())) ||
                    (types.length > 0 && !types.includes(l.type.toLowerCase())) ||
                    (shapes.length > 0 && !shapes.includes(l.shape.toLowerCase())) ||
                    (pieces.length > 0 &&
                        !pieces.includes(String(l.pieces).toLowerCase())));
            }
            else {
                return l.type === 'Multiple';
            }
        }) ?? item.layouts[0];
    }
    else {
        isSelectedLayout = true;
    }
    if (rooms.length > 0) {
        if (hasActiveFilter || isSelectedLayout) {
            previewImage = findDesiredRoomInLayout(selectedLayout, rooms);
        }
        else {
            previewImage = findDesiredRoomInLayout(selectedLayout, rooms);
            if (previewImage === undefined) {
                const layoutWithRoom = item.layouts.find(l => {
                    previewImage = findDesiredRoomInLayout(l, rooms);
                    return previewImage !== undefined;
                });
                if (layoutWithRoom !== undefined) {
                    selectedLayout = layoutWithRoom;
                }
            }
        }
    }
    if (previewImage === undefined && selectedLayout.room_previews !== undefined) {
        previewImage = selectedLayout.room_previews[0];
    }
    return {
        link: (selectedLayout.url ?? item.url).replace('/?', '?'),
        image: isNotNullOrUndef(selectedLayout.preview_3d) && selectedLayout.preview_3d.length > 0
            ? selectedLayout.preview_3d
            : isNotNullOrUndef(selectedLayout.preview_main) && selectedLayout.preview_main.length > 0
                ? selectedLayout.preview_main
                : item.main_image,
        selectedLayout,
        previewImage
    };
};
